import styles from "./ContactForm.module.css";
import React, { useState } from "react";
import api from "../../api/axois";

// Served from /public, not a JS module import — Vite doesn't bundle public/ assets.
const slide2 = "/images/contact.jpg";

const ContactForm = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const payload = {
        first_name: firstName,
        last_name: lastName,
        phone,
        email,
        message,
        source: 'contact_page',
      };
      const res = await api.post('/contact', payload);
      setSuccess(res.data.message || 'Message sent. We will contact you soon.');
      setFirstName(''); setLastName(''); setPhone(''); setEmail(''); setMessage('');
    } catch (err) {
      setError(err.response?.data?.message || (err.response?.data?.errors ? JSON.stringify(err.response.data.errors) : 'Failed to send message'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className={styles.contactPage}>
      <div className={styles.contactImageContainer}>
        <img src={slide2} alt="Contact lounge" className={styles.contactImage} />
      </div>

      <div className={styles.contactFormContainer}>
        <h2 className={styles.contactTitle}>Reach out to us</h2>
        <p className={styles.contactSubtitle}>
          Get in touch with us to turn your vision into reality. We're here to
          answer your questions, explore your ideas, and start your next big
          project.
        </p>

        <form className={styles.contactForm} onSubmit={handleSubmit}>
          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label>First Name</label>
              <input value={firstName} onChange={e => setFirstName(e.target.value)} type="text" placeholder="Enter First name" />
            </div>
            <div className={styles.formGroup}>
              <label>Last Name</label>
              <input value={lastName} onChange={e => setLastName(e.target.value)} type="text" placeholder="Enter Last Name" />
            </div>
          </div>

          <div className={styles.formRow}>
            <div className={styles.formGroup}>
              <label>Phone Number</label>
              <input value={phone} onChange={e => setPhone(e.target.value)} type="text" placeholder="08012345678" />
            </div>
            <div className={styles.formGroup}>
              <label>Email</label>
              <input value={email} onChange={e => setEmail(e.target.value)} type="email" placeholder="someone@gmail.com" required />
            </div>
          </div>

          <div className={`${styles.formGroup} ${styles.fullWidth}`}>
            <label>Message (Optional)</label>
            <textarea value={message} onChange={e => setMessage(e.target.value)} rows="5" placeholder="Tell us what’s on your mind" />
          </div>

          {error && <div className={styles.contactError}>{error}</div>}
          {success && <div className={styles.contactSuccess}>{success}</div>}

          <button type="submit" className={styles.sendButton} disabled={loading}>
            {loading ? 'Sending...' : 'SEND'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
